import { BankAccountsActionTypes } from './action-types';
import { BankAccountsState } from 'models';
import { Reducer } from 'redux';
import { ActionTypes } from 'store/helpers';

const initialState: BankAccountsState = {
  bankAccounts: [],
  loading: false,
  error: false,
  sortParams: {
    order: 'asc',
    orderBy: 'Operator.Name',
    type: 'string',
  },
};

export const reducer: Reducer<BankAccountsState, ActionTypes> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case BankAccountsActionTypes.REQUEST_BANK_ACCOUNTS_START:
      return { ...state, error: false, loading: true };
    case BankAccountsActionTypes.REQUEST_BANK_ACCOUNTS_SUCCESS:
      return { ...state, bankAccounts: action.payload, loading: false };
    case BankAccountsActionTypes.REQUEST_BANK_ACCOUNTS_FAILED:
      return { ...state, error: true, loading: false };
    case BankAccountsActionTypes.SET_SORT_PARAMS:
      return {
        ...state,
        sortParams: {
          ...state.sortParams,
          order: state.sortParams.order === 'asc' ? 'desc' : 'asc',
          orderBy: action.payload.id,
          type: action.payload.type,
        },
      };
    default:
      return state;
  }
};
